import NavTab from './NavTab'
import Tab from './Tab'

export { NavTab, Tab }
